<template>
  <BoxedText
    :box-color-class="bgColorClass"
    element="label"
    text-class="heading-xxs"
    :line-height="lineHeight ?? 'leading-[180%]'"
  >
    <span
      :aria-hidden="ariaLabel ? true : false"
      :class="textColorClass"
      v-html="text"
    >
    </span>
    <span v-if="ariaLabel" class="sr-only">
      {{ ariaLabel }}
    </span>
  </BoxedText>
</template>

<script lang="ts" setup>
import { labelColorClass } from '~/utils';
interface Props {
  color?: string;
  text?: string;
  ariaLabel?: string;
  lineHeight?: string;
}
const props = defineProps<Props>();

const bgColorClass = computed(() => labelColorClass(props.color));
const textColorClass = computed(() => {
  if (bgColorClass.value === 'bg-label-black') {
    return 'text-white-50';
  }

  return 'text-text-on-highlight';
});
</script>

<style lang="scss" scoped></style>
